import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.default,
    minHeight: '100%',
  },
  titleContainer: {
    marginBottom: theme.spacing(4),
  },
  welcomeTitle: {
    fontWeight: 700,
    color: theme.palette.text.primary,
    fontSize: '1.75rem',
  },
  welcomeSubtitle: {
    color: theme.palette.text.secondary,
    marginTop: theme.spacing(0.5),
  },
  kpiGrid: {
    marginBottom: theme.spacing(4),
  },
  chartsGrid: {
    marginBottom: theme.spacing(4),
  },
}))

export default useStyles
